import { useEffect, useState } from 'react'
import fbFn from '~/modules/firebase'

interface Claims {
  is_canfleet?: boolean
  is_breadstack?: boolean
  is_chatso?: boolean
  [key: string]: any
}

export const useClaims = () => {
  const [claims, setClaims] = useState<Claims | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        setLoading(true)
        const res = await fbFn.getClaimsToken()
        setClaims(res?.claims || null)
        setError(null)
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error('Failed to fetch claims'),
        )
        setClaims(null)
      } finally {
        setLoading(false)
      }
    }

    fetchClaims()
  }, [])

  return { claims, loading, error }
}
